import { Button, PageContent, PageHeader } from '@/components';
import { TemplateAbilityGuard } from '@/features/authentication/_components/TemplateAbilityGuard';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkflowTemplateListContent } from '../components/template';
import {
  WorkflowTemplateDrawerStateProvider,
  useWorkflowTemplateDrawerState,
} from '../components/template/WorkflowTemplateDrawerStateProvider';

const WorkflowTemplateListPage: FC = () => {
  const { t } = useTranslation();

  return (
    <TemplateAbilityGuard showDenied>
      <WorkflowTemplateDrawerStateProvider>
        <PageHeader
          title={t('workflow.template')}
          breadcrumbs={[
            {
              title: t('workflow'),
              href: '/workflow',
            },
            { title: t('workflow.template') },
          ]}
          buttons={<CreateWorkflowTemplateButton />}
        />
        <PageContent>
          <WorkflowTemplateListContent />
        </PageContent>
      </WorkflowTemplateDrawerStateProvider>
    </TemplateAbilityGuard>
  );
};

export default WorkflowTemplateListPage;

const CreateWorkflowTemplateButton: FC = () => {
  const { t } = useTranslation();
  const { setDrawerState } = useWorkflowTemplateDrawerState();
  return (
    <Button
      type="primary"
      onClick={() => {
        setDrawerState({ open: true, operation: 'create' });
      }}
    >
      {t('create')}
    </Button>
  );
};
